module.exports = __webpack_public_path__ + "img/mobileScreen.3bfd8c38.png";